<script lang="ts" setup>
defineProps<{
  type?: 'success' | 'info' | 'warning' | 'error'
  size?: 'sm' | 'md' | 'lg'
  label: string
  link?: boolean
}>()
</script>

<template>
  <n-popover trigger="hover">
    <template #trigger>
      <!-- <a
        class="m-tag"
        :href="link ? `/search?q=${label}` : undefined"
        target="_blank"
        :class="[type, size || 'md', link ? 'is-link' : 'not-link']"
      >
        {{ label }}
      </a> -->
      <a
        class="m-tag"
        :href="link ? `/tag/${label}` : undefined"
        target="_blank"
        :class="[type, size || 'md', link ? 'is-link' : 'not-link']"
      >
        {{ label }}
      </a>
    </template>
    <span>{{ label }}</span>
  </n-popover>
</template>

<style lang="scss" scoped>
.m-tag {
  text-decoration: none;
  padding: 2px 10px;
  width: fit-content;
  border-radius: 12px;
  background-color: var(--color-gray-100);
  color: var(--color-gray-700);
  max-width: 160px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  display: inline-block;
  margin: 2px 4px 2px 0;

  &.is-link {
    cursor: pointer;
  }

  &.not-link {
    cursor: default;
  }

  &.sm {
    height: 18px;
    line-height: 16px;
    font-size: 12px;
  }

  &.md {
    height: 22px;
    line-height: 20px;
    font-size: 12px;
  }

  &.lg {
    height: 28px;
    line-height: 24px;
    font-size: 14px;
  }

  &.success {
    background-color: var(--color-green-100);
    color: var(--color-green-800);
  }

  &.info {
    background-color: var(--color-blue-100);
    color: var(--color-blue-800);
  }

  &.warning {
    background-color: var(--color-yellow-100);
    color: var(--color-yellow-800);
  }

  &.error {
    background-color: var(--color-red-100);
    color: var(--color-red-800);
  }
}
</style>
